"use client";

import { useEffect, useState } from "react";
import { deobfuscateEmailAdvanced, OBFUSCATED_EMAIL_DEV } from "@/app/lib/emailObfuscation";

export default function Impressum() {
    const [email, setEmail] = useState<string>("");

    useEffect(() => {
        try {
            const deobfuscated = deobfuscateEmailAdvanced(OBFUSCATED_EMAIL_DEV);
            setEmail(deobfuscated);
        } catch {
            // Silently fail
        }
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-[#bfe6ff] via-[#8ccaff] to-[#66aafc] py-20 px-4">
            <div className="mt-10  max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl p-8 md:p-12 border-[6px] border-[#1d2b4f]">
                <h1 className="text-4xl md:text-6xl font-luckiest text-[#1d2b4f] mb-8 text-center">
                    Impressum
                </h1>
                
                <div className="space-y-6 font-[Poppins] text-[#1d2b4f]">
                    <section>
                        <p className="leading-relaxed">
                            Webentwicklung Möwes<br />
                            Timo Möwes<br />
                            Schillerring 11<br />
                            13407 Berlin
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold mb-3">Kontakt</h2>
                        <p className="leading-relaxed">
                            Telefon: +49 (0) 1523 61 24 846<br />
                            E-Mail: {email || "wird geladen..."}
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold mb-3">Angaben zur Berufs­haftpflicht­versicherung</h2>
                        <p className="leading-relaxed font-semibold">
                            Name und Sitz des Versicherers:
                        </p>
                        <p className="leading-relaxed">
                            Hiscox SA<br />
                            Arnulfstraße 31<br />
                            80636 München
                        </p>
                        <p className="leading-relaxed font-semibold mt-4">
                            Geltungsraum der Versicherung:
                        </p>
                        <p className="leading-relaxed">
                            Deutschland
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold mb-3">EU-Streitschlichtung</h2>
                        <p className="leading-relaxed">
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                            <a 
                                href="https://ec.europa.eu/consumers/odr/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[#5ba0ff] hover:underline"
                            >
                                https://ec.europa.eu/consumers/odr/
                            </a>.<br />
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold mb-3">Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>
                        <p className="leading-relaxed">
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </p>
                    </section>

                    <p className="leading-relaxed text-sm mt-8 text-[#1d2b4f]/70">
                        Quelle:{" "}
                        <a 
                            href="https://www.e-recht24.de" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-[#5ba0ff] hover:underline"
                        >
                            https://www.e-recht24.de
                        </a>
                    </p>
                </div>

                <div className="mt-12 pt-8 border-t-2 border-[#1d2b4f]/20 text-center">
                    <a 
                        href="/"
                        className="inline-flex items-center justify-center gap-2 rounded-sm border-[3px] border-[#1d2b4f] bg-[#ffe066] px-6 py-3 text-base font-[Poppins] font-bold text-[#1d2b4f] shadow-[3px_3px_0_#1d2b4f] transition-colors duration-200 hover:bg-[#5ba0ff] hover:text-white"
                    >
                        Zurück zur Startseite
                    </a>
                </div>
            </div>
        </div>
    );
}
